<template>
  <div class="report">
    <div class="title">{{name}}</div>
    <div class="company">处置单位: {{company}}</div>
    <div class="head">制表: <div></div>审核: <div></div>负责人: <div></div> <label>制表⽇期: <div>{{time}}</div></label></div>
    <div v-for="(items,index) in list">
      <table :class="{mt10:index>0}">
        <tr>
          <th>医疗卫⽣机构名称</th>
          <th>医疗卫⽣机构编号</th>
          <th>感染性(箱)</th>
          <th>感染性(kg)</th>
          <th>损伤性(箱)</th>
          <th>损伤性(kg)</th>
        </tr>
        <tr v-for="item in items">
          <td>{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td>{{item[5]}} </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Month1",
    data(){
      return {
        name:"医疗废物处置⽉报表",
        company:"乐⼭市净源垃圾处理有限公司",
        time:"2000-00-00",
        list:[]
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
          this.list=res.list;
          this.time=res.date;
          this.company=res.factory;
        } )
      },

    },
    created(){
      this.init()
    }
  }

</script>
<style scoped>
  .report{
    width: 100%;color: #000;}
  .report .title{height:35px;line-height: 35px;font-weight: bold;font-size: 14px;}
  table{
    border-collapse: collapse;
    width: 100%;
    margin-top:9px;
  }
  table td{border: 1px solid #000;font-size: 10px;height: 22px;}
  table th{border: 1px solid #000;font-size: 10px;height:22px;}

  .head{height:20px;line-height:20px;margin-top: 14px;text-align: left;font-size: 12px}
  .head>div,.head>label>div{display: inline-block;width: 100px;text-align: left; border-bottom: 1px solid #000;margin-right: 20px}
  .head>label{display: inline-block;float: right;}
  .head>label>div{margin: 0;}
  .company{font-size: 14px;font-weight: bold;height: 10px;line-height: 10px;}
  .mt10{margin-bottom:30px }
  .mt10 td{height: 22px}
</style>



// WEBPACK FOOTER //
// src/view/report/month1.vue